import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

function Bonus() {
    const navigate = useNavigate();
    return (
        <div>

            <h1>Create or Update Bonus Plans</h1>

            <Button mt="md" variant="gradient"
                onClick={() => navigate('types-of-months')}
                gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
            >
                Types of Months
            </Button>
            <p>These are the types of months.</p>

            <Button mt="md" variant="gradient"
                onClick={() => navigate('beginners')}
                gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
            >
                Beginners Bonus
            </Button>
            <p>This bonus is given to beginners when they reach a growth step.</p>

            <Button mt="md" variant="gradient"
                onClick={() => navigate('advanced')}
                gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
            >
                Advanced Bonus
            </Button>
            <p>This bonus is given to advanced creators based on their monthly earnings</p>

            <Button type="submit" mt="md" variant="gradient" disabled
                gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
            >
                Growth Bonus
            </Button>
            <p>This bonus is given to advanced creators based on their evolution</p>
        </div>
    );
}
export default Bonus;
